// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"industries_fadeIn__MRkMA","cta":"industries_cta__oCR6o"};